
/* 
  Generate redux state for typical datalayer with nested categories with standart actions

  const  lauObjectsExport = lauObjectsData.export();
  export const lauObjects = lauObjectsExport.lauObjects;
  export default lauObjectsExport;
*/

export default class dataLayerReducer {


  constructor({key, defaultState}) {

    this.defaultState = defaultState;
    this.name = key;

    this.recursiveLoop = this.recursiveLoop.bind(this);
    this.getActive = this.getActive.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
    this.getSubCats = this.getSubCats.bind(this);
    this.getActiveObject = this.getActiveObject.bind(this);
    this.getActiveIds = this.getActiveIds.bind(this);
    this.addData = this.addData.bind(this);
    this.reducerExtender = this.reducerExtender.bind(this);
  }

  addData(categoryID, state, data) {

    if(categoryID !== null) {

      this.recursiveLoop(state.data, (category) => {

        if (category.id == categoryID) {

          category.childs = data;
        }

      });
    }
   
   return state;
  }

  getColorMap (state) {

    var colorMap = {};

    this.recursiveLoop(state.data, (category) => {

      if(category.alias) {
          colorMap[category.alias] = category.color; 
        } else {
          colorMap[category.name] = category.color; 
        }

    });

    return colorMap;
  }

  getActive (state) {

    const activeInd = [];
    this.recursiveLoop(state.data, (categ) => {

      if(typeof categ.active === 'boolean' && categ.active) {

        if(typeof categ.alias !== 'undefined') {

          activeInd.push(categ.alias);
        } else {

          activeInd.push(categ.name);
        }
      }
    });

    return activeInd;
  }

  getActiveIds(state) {

    const activeInd = [];
    this.recursiveLoop(state.data, (categ) => {

      if(typeof categ.id !== 'undefined' && categ.active) {

          activeInd.push(categ.id);
        
      }
    });

    return activeInd;
  }

  getActiveObject (state) {

    const activeInd = [];
    this.recursiveLoop(state.data, (categ) => {

      if(typeof categ.active === 'boolean' && categ.active) {

          activeInd.push(categ);
      }
    });

    return activeInd;
  }

  recursiveLoop (data, cb, depth = 0) {

    if( depth > 10 ) {
      throw new('ERROR: max recursive depth!');
    }

    for ( var i = 0, len = data.length; i < len; i++ ) {

        cb(data[i], depth, i);

        if(typeof data[i].childs === 'object') {
          this.recursiveLoop(data[i].childs, cb, depth++);
        }
    }
  }

  isActiveByName (name, state) {

    var data = state.data;
    var activeInduestries = state.active;

    for ( var i = data.length - 1; i >= 0; i-- ) {
      if( data[i] === name ) {
        return;
      }
    }
  }

  isActiveById (id, state) {

    var data = state.data;
    var activeInduestries = state.active;

    for ( var i = data.length - 1; i >= 0; i-- ) {
      if( data[i] === id ) {
        return;
      }
    }
  }

  getSubCats (state) {

    var categories = [];

    for (var i = state.data.length - 1; i >= 0; i--) {
      var childs = state.data[i].childs;
      for (var n = childs.length - 1; n >= 0; n--) {
        var childs = childs[n];

        categories.push(childs.name);
      }
    }

    return categories;
  }

  toggleAll (newstate, bolActive) {

    for (var i = newstate.data.length - 1; i >= 0; i--) {
          newstate.data[i].active = bolActive;

          if(typeof newstate.data[i].childs !== 'undefined') {
            for (var n = newstate.data[i].childs.length - 1; n >= 0; n--) {
              if(!bolActive){
                newstate.data[i].childs[n].active = bolActive;
              }
              
              newstate.data[i].childs[n] = Object.assign({}, newstate.data[i].childs[n]);
            }
          }
        }

        return newstate;
  }

  //extend this function to add more state update cases in child class
  reducerExtender(state, action) {    return false;  }

  reducerFunction(){

    var this_ = this;
    return function(state = this_.defaultState, action){

      var newState = this_.reducerExtender(state, action);
      if(newState) {
        return newState;
      }

      switch (action.type) {
        case this_.name + "_TOGGLE":

          if(typeof action.data !== 'undefined') {

            return Object.assign({}, state, {enabled: action.data});
          }

          return Object.assign({}, state, {enabled: !state.enabled});
          break;
        case this_.name + "_LOAD_DATA":

          var newstate = Object.assign({}, state);

          return Object.assign({}, state, newstate);
          break;
        case this_.name + "_TOGGLE_DATA":

          var newstate = Object.assign({}, state);

          var indexes = action.indexes;
          if(indexes.length === 1) {

            
            newstate.data[indexes[0]].active = (newstate.data[indexes[0]].active ? false : true);

            if(newstate.data[indexes[0]].childs) {

              this_.recursiveLoop(newstate.data[indexes[0]].childs, (entry) =>{
                entry.active = newstate.data[indexes[0]].active;
              });

              
            }


            newstate.data[indexes[0]] = Object.assign({}, newstate.data[indexes[0]]);
          }

        

          if(indexes.length > 1) {

            var selected = 0;
            var dataLevel = newstate.data;

            for (var i = 0, len = indexes.length; i < len; i++) {
              selected = dataLevel[indexes[i]];

              if(typeof selected.childs !== 'undefined') {
                dataLevel = selected.childs;
              }
            }

            selected.active = !selected.active;

             if(selected.childs) {

              this_.recursiveLoop(selected.childs, (entry) =>{
                entry.active = selected.active;
              });

              
            }
          }

          return newstate;
     /*   case SET_POPUP:

          return Object.assign({}, state, {activePopupData: action.data});
          break;
        case TOGGLE_ACTIVE_KG:
        case TOGGLE_ACTIVE_R:
        case TOGGLE_ACTIVE_S:
        case TOGGLE_POP:
          //DISABLE ALL
          var newstate = toggleAll(Object.assign({}, state), false);
          

          return newstate;
        break;  */
        case this_.name + "_ADD_DATA":

          return this_.addData(action.id, Object.assign({}, state), action.data);

          break;
        case this_.name + "_TOGGLE_ALL":

          var someActive = false;
          this_.recursiveLoop(state.data, (entry)=>{
            if(entry.active) {
              someActive = true;
            }
          });

          if(someActive) {
            var newstate = this_.toggleAll(Object.assign({}, state), false);
          } else {
            var newstate = this_.toggleAll(Object.assign({}, state), true);
          }

          return newstate;
          break;
        case this_.name + "_TOGGLE_BY_IDS":
            var toggle = true;
        case this_.name + "_ACTIVATE_BY_IDS":

            var newstate = Object.assign({}, state);

            var activeIDs = action.data;

            this_.recursiveLoop(state.data, (entry) => {
              if(typeof entry.id !== 'undefined' && activeIDs.indexOf(entry.id) > -1) {
                if(typeof toggle !== 'undefined') {
                  entry.active = !entry.active;
                } else {
                  entry.active = true;
                }
                
              } else {
                if(typeof toggle === 'undefined') {
                  entry.active = false;
                }
                
              }
            });

          return newstate;
          break;
        case this_.name + "_TOGGLE_BY_IDS_SINGLE":

            var newstate = Object.assign({}, state);

            var activeIDs = action.data;

            this_.recursiveLoop(state.data, (entry) => {
              if(typeof entry.id !== 'undefined' && activeIDs.indexOf(entry.id) > -1) {
                  entry.active = !entry.active;
              } else {
                  entry.active = false;
              }
            });

          return newstate;
          break;
        default:
          return state;
      }
    }
  }

  exportExtender() {

    return {};
  }

  export() {

    var exportObject = {
      addData: this.addData,
      getColorMap: this.getColorMap,
      getActive: this.getActive,
      getSubCats: this.getSubCats,
      toggleAll: this.toggleAll,
      isActiveByName: this.isActiveByName,
      getActiveObject: this.getActiveObject,
      getActiveIds: this.getActiveIds,
      recursiveLoop: this.recursiveLoop,
      [this.name]: this.reducerFunction()
    }

    return Object.assign(exportObject, this.exportExtender());
  }
}




// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/dataLayer/reducer.js